var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "new_myPlan_box",
        style: `background:${
          _vm.planId == _vm.item.id ? "rgb(240, 250, 255)" : "white"
        };`,
      },
      [
        _c("div", { staticClass: "box_title" }, [
          _vm.planId == _vm.item.id
            ? _c("span", { staticClass: "editing" }, [_vm._v("编辑中")])
            : _vm._e(),
          _c("span", { staticClass: "planIdBox" }, [
            _vm._v("草稿:" + _vm._s(_vm.item.id)),
          ]),
          _c("img", { staticClass: "avatar", attrs: { alt: "" } }),
          _c("span", { staticClass: "userName" }, [
            _vm._v(_vm._s(_vm.item.createName)),
          ]),
          _c("span", { staticClass: "planNumber" }, [
            _vm._v("方案数"),
            _c("span", { staticClass: "number" }, [
              _vm._v(_vm._s(_vm.item.budgetMains.length)),
            ]),
          ]),
          _vm.item.budgetMains[_vm.item.showIndex]
            ? _c("span", { staticClass: "planNumber" }, [
                _vm._v("浏览"),
                _c("span", { staticClass: "number" }, [
                  _vm._v(
                    _vm._s(_vm.item.budgetMains[_vm.item.showIndex].viewsNumber)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.item.incomePrice
            ? _c(
                "span",
                { staticStyle: { color: "#DB4E1A", "margin-right": "0.1rem" } },
                [_vm._v("收入 " + _vm._s(_vm.item.incomePrice))]
              )
            : _vm._e(),
          _vm.item.expenditurePrice
            ? _c("span", { staticStyle: { color: "#DB4E1A" } }, [
                _vm._v("支出 " + _vm._s(_vm.item.expenditurePrice)),
              ])
            : _vm._e(),
          _vm.showDelete && !_vm.item.incomePrice && !_vm.item.expenditurePrice
            ? _c(
                "span",
                {
                  staticClass: "del_button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.delPlan(_vm.item)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-delete" })]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "left_img_box" }, [
          _vm.item.budgetMains[_vm.item.showIndex] &&
          _vm.item.budgetMains[_vm.item.showIndex].imageUrl
            ? _c("img", {
                attrs: {
                  src: _vm.item.budgetMains[_vm.item.showIndex].imageUrl,
                  alt: "",
                  width: "100%",
                  height: "100%",
                },
              })
            : _c("img", {
                attrs: {
                  src: require("@/assets/jpg/text.jpg"),
                  alt: "",
                  width: "100%",
                  height: "100%",
                },
              }),
          _vm.item.budgetMains[_vm.item.showIndex] &&
          _vm.item.budgetMains[_vm.item.showIndex].updateTime
            ? _c("div", { staticClass: "time_box" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dateFormatYMD(
                        _vm.item.budgetMains[_vm.item.showIndex].updateTime,
                        "-"
                      )
                    ) +
                    " " +
                    _vm._s(
                      _vm.dateFormatHM(
                        _vm.item.budgetMains[_vm.item.showIndex].updateTime
                      )
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.item.budgetMains.length > 1
            ? _c("div", { staticClass: "planIndex_box" }, [
                _vm._m(0),
                _c("div", { staticClass: "box_right" }, [
                  _vm._v("方案" + _vm._s(_vm.item.showIndex + 1)),
                ]),
              ])
            : _vm._e(),
          !_vm.isLook
            ? _c("div", [
                _vm.showInquiryButton &&
                _vm.item.inquiries &&
                _vm.item.inquiries.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "xundan_box",
                        on: {
                          click: function ($event) {
                            return _vm.goXunList(_vm.item)
                          },
                        },
                      },
                      [
                        _vm._v("查看详情 "),
                        _c("div", { staticClass: "xundan_icon" }, [
                          _vm._v("询"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.showCopy
                  ? _c(
                      "div",
                      {
                        staticClass: "copy_button",
                        staticStyle: { right: "0.5rem" },
                        on: {
                          click: function ($event) {
                            return _vm.showPlan(_vm.item)
                          },
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "将该团设置为全公司人可见",
                              placement: "top",
                            },
                          },
                          [
                            _c("svg-icon", {
                              attrs: {
                                iconClass:
                                  _vm.item.isShow === 0
                                    ? "eye-close"
                                    : "eye-open",
                                systemColor: "#7D7D7D",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCopy
                  ? _c(
                      "div",
                      {
                        staticClass: "copy_button",
                        staticStyle: { right: "0.27rem" },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "复制该团内容并新建一个新团",
                              placement: "top",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/svg/semiDesign-semi-icons-copy_add.svg"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.copyPlan(_vm.item)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCopy && _vm.item.planLock == 0
                  ? _c(
                      "div",
                      {
                        staticClass: "copy_button",
                        staticStyle: { right: "0.27rem" },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                "锁定该团（锁入之后不可再对该团进行任何的操作）",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-lock",
                              on: {
                                click: function ($event) {
                                  return _vm.lockPlan(_vm.item)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCopy
                  ? _c(
                      "div",
                      {
                        staticClass: "copy_button",
                        staticStyle: { right: "0.05rem" },
                        on: {
                          click: function ($event) {
                            return _vm.sharePlan(_vm.item)
                          },
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "将该团分享给客户",
                              placement: "top",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/svg/iconPark-share-one.svg"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.showCopy
                  ? _c(
                      "div",
                      {
                        staticClass: "copy_button",
                        staticStyle: { right: "0.05rem" },
                        on: {
                          click: function ($event) {
                            return _vm.recoveryPlan(_vm.item)
                          },
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "恢复该团到我的行程里面",
                              placement: "top",
                            },
                          },
                          [
                            _c("svg-icon", {
                              attrs: { iconClass: "recovery" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "right_info_box" },
          [
            _c(
              "el-carousel",
              {
                ref: "elCarousel" + _vm.index,
                staticClass: "lunbo_box",
                attrs: {
                  autoplay: !_vm.item.autoplay,
                  arrow: "never",
                  "indicator-position": "outside",
                  height: "1.17rem",
                  interval: 4000,
                },
                on: {
                  change: (newIndex, oldIndex) => {
                    _vm.changeLunBo(newIndex, oldIndex, _vm.item)
                  },
                },
              },
              _vm._l(_vm.item.budgetMains, function (itemTwo, indexTwo) {
                return _c("el-carousel-item", { key: indexTwo }, [
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.replaceStroke(_vm.item, itemTwo)
                        },
                      },
                    },
                    [
                      _c("el-tooltip", { attrs: { placement: "top" } }, [
                        _vm.showDelete
                          ? _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  _vm._s(itemTwo.planName) +
                                    _vm._s(itemTwo.planName1)
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(_vm.item.planName))]
                            ),
                        _c("div", { staticClass: "right_planName" }, [
                          _vm.showDelete
                            ? _c("span", [_vm._v(_vm._s(itemTwo.planName))])
                            : _c("span", [_vm._v(_vm._s(_vm.item.planName))]),
                          _c("span", { staticClass: "greenPlace" }, [
                            _vm._v(_vm._s(itemTwo.planName1)),
                          ]),
                          itemTwo.budgetName && itemTwo.budgetName != ""
                            ? _c(
                                "span",
                                {
                                  staticClass: "title",
                                  staticStyle: { "font-weight": "normal" },
                                },
                                [_vm._v("  " + _vm._s(itemTwo.budgetName))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "right_price_box" }, [
                        _c("div", { staticClass: "start_time_box" }, [
                          _c("div", { staticClass: "time_top" }, [
                            _vm._v(
                              _vm._s(
                                _vm.dateFormatMD(itemTwo.departureDate, "/")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "time_bottom" }, [
                            _c("div", { staticClass: "left" }, [_vm._v("D1")]),
                            _c("div", { staticClass: "right" }, [
                              _vm._v(
                                _vm._s(
                                  new Date(itemTwo.departureDate).getFullYear()
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "price_items one" }, [
                          _c("div", { staticClass: "number" }, [
                            _vm._v(_vm._s(itemTwo.useNumber)),
                          ]),
                          _c("div", { staticClass: "title" }, [_vm._v("人数")]),
                        ]),
                        _c("div", { staticClass: "price_items one" }, [
                          _c("div", { staticClass: "number" }, [
                            _vm._v(_vm._s(itemTwo.spotSize)),
                          ]),
                          _c("div", { staticClass: "title" }, [_vm._v("景点")]),
                        ]),
                        _c("div", { staticClass: "price_items one" }, [
                          _c("div", { staticClass: "number" }, [
                            _vm._v(_vm._s(itemTwo.stateSize)),
                          ]),
                          _c("div", { staticClass: "title" }, [_vm._v("项目")]),
                        ]),
                        _c("div", { staticClass: "grayLine" }),
                        _vm.showDelete
                          ? _c("div", { staticClass: "price_items two" }, [
                              _c("div", { staticClass: "number" }, [
                                _c("span", { staticClass: "black_font" }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        itemTwo.budgetDetailResult.totalPrice /
                                        itemTwo.useNumber
                                      ).toFixed(2)
                                    )
                                  ),
                                ]),
                                _vm._v("￥"),
                              ]),
                              _c("div", { staticClass: "title" }, [
                                _vm._v("成本/人"),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "price_items two" }, [
                          _c("div", { staticClass: "number" }, [
                            _c("span", { staticClass: "black_font" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      itemTwo.budgetDetailResult
                                        .saleTotalPrice / itemTwo.useNumber
                                    ).toFixed(2)
                                  )
                              ),
                            ]),
                            _vm._v("￥ "),
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("报价/人"),
                          ]),
                        ]),
                        _vm.showDelete
                          ? _c("div", { staticClass: "price_items two" }, [
                              _c("div", { staticClass: "number" }, [
                                _c("span", { staticClass: "black_font" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (
                                          (itemTwo.budgetDetailResult
                                            .saleTotalPrice -
                                            itemTwo.budgetDetailResult
                                              .totalPrice) /
                                          itemTwo.useNumber
                                        ).toFixed(2)
                                      )
                                  ),
                                ]),
                                _vm._v("￥ "),
                              ]),
                              _c("div", { staticClass: "title" }, [
                                _vm._v("利润/人"),
                              ]),
                            ])
                          : _c(
                              "div",
                              { staticClass: "price_items two" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [_vm._v("查看详情")]
                                ),
                              ],
                              1
                            ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
              1
            ),
          ],
          1
        ),
      ]
    ),
    _vm.item.budgetMains.length > 1
      ? _c(
          "ul",
          { staticClass: "changeLunBox" },
          _vm._l(_vm.item.budgetMains, function (itemTwo, indexTwo) {
            return _c("li", {
              key: indexTwo,
              class: _vm.item.showIndex === indexTwo ? "checkedLi" : "",
              on: {
                click: function ($event) {
                  return _vm.changeBudgetIndex(_vm.item, indexTwo, _vm.index)
                },
              },
            })
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box_left" }, [
      _c("img", {
        attrs: { src: require("@/assets/svg/antFill-heart.svg"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }